module.exports = __webpack_public_path__ + "media/src/images/abouts/items/online/u-next-d1c8c04a74aa920fc79d645c3f6c9e54.png";